import moment from 'moment';
import 'moment/locale/lv';

export default moment;